import { Dashboard } from "shared/app/Dashboard/Dashboard";
import type { PartnerUserPermissions } from "providers/Auth";

import type { RouteConfig } from "../types";
import { RedirectToHome } from "../redirects";
import { getMainRoutes } from "./main-routes";
import { getSettingsRoutes } from "./settings-routes";

type PartnerType = {
  isBoomScreen: boolean;
  isBoomCRM: boolean;
  isNativeChatActive: boolean;
  isSDK: boolean;
  adminPrivileges: boolean;
  isCommunicationSms: boolean;
  isCommunicationEmail: boolean;
  isBoomScreenOutcomes: boolean;
  isProvisionedPhoneNumber: boolean;
  isBoomOps: boolean;
  isTasks: boolean;
  isLockboxes: boolean;
  isMarketRent: boolean;
  isOwnerReports: boolean;
  isShowings: boolean;
  isCrmListingSync: boolean;
  isCollectionsOutstandingBalance: boolean;
  isListingFraudAlerts: boolean;
  isRentReporting: boolean;
  isBoomProducts: boolean;
};

export const getActiveRoutes = (
  type: PartnerType,
  permissions: PartnerUserPermissions
): RouteConfig[] => [
  { path: "/", layout: Dashboard, children: getMainRoutes(type, permissions) },
  {
    path: "settings",
    layout: Dashboard,
    children: getSettingsRoutes(type, permissions)
  },
  { path: "/login", component: RedirectToHome },
  { path: "/forgot-password", component: RedirectToHome },
  { path: "/sign-up", component: RedirectToHome },
  { path: "/onboarding", component: RedirectToHome }
];
